module.exports = __webpack_public_path__ + "media/images/application/template/map-cluster-markers/m4-87358c4836c8d2cc6a7a2602df63855e.png";